import { FirebaseDocRefType } from 'firebase/index'
import { StockUnionType } from 'types/stock'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { BreadType } from 'types/bread'
import { fetchBreadsAction } from 'reducks/bread/actions'
import { fetchBreadByRef } from 'reducks/bread/operations'

const fetchBreads = (
  storeRef: FirebaseDocRefType,
  status: 'all' | 'public',
  sortKey?: string,
  type?: StockUnionType
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    const breadRefs: FirebaseDocRefType[] = []
    const manufacturerRef = getState().auth.manufacturer_ref

    const storeBreadQuery =
      typeof manufacturerRef !== 'undefined'
        ? storeRef
            .collection('store_breads')
            .where('manufacturer_ref', '==', manufacturerRef)
            .orderBy('created_at', 'asc')
        : storeRef.collection('store_breads').orderBy('created_at', 'asc')

    // breadsへのrefを取得する
    const snapshots = await storeBreadQuery.get()

    for (let i = 0; i < snapshots.docs.length; i = (i + 1) | 0) {
      const snapshot = snapshots.docs[i]
      const data = snapshot.data()
      if (!data) continue
      if (!('bread_ref' in data)) continue
      breadRefs.push(data.bread_ref)
    }

    // breadsのデータを取得する
    const promises = []
    for (let i = 0; i < breadRefs.length; i = (i + 1) | 0) {
      const ref = breadRefs[i]
      promises.push(fetchBreadByRef(ref))
    }

    let breads: BreadType[] = await Promise.all(promises)
      .then((result: Array<BreadType | undefined>) => {
        return result.filter((bread) => typeof bread !== 'undefined') as BreadType[]
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    if (status === 'public') {
      breads = breads.filter((bread) => bread.status === 'public')
    }
    // 商品typeの指定があれば絞り込む
    if (type === 'daily') {
      breads = breads.filter((bread) => bread.is_type_daily)
    } else if (type === 'preorder') {
      breads = breads.filter((bread) => bread.is_type_preorder)
    } else if (type === 'shared') {
      breads = breads.filter((bread) => bread.is_type_shared)
    } else if (type === 'delivery') {
      breads = breads.filter((bread) => bread.is_type_delivery)
    }
    // 削除済みの商品は含まない
    breads = breads.filter((bread) => bread.status !== 'delete')

    // sortKeyに応じてソート方法を変更
    switch (sortKey) {
      case 'order':
        breads.sort((a, b) => (a.order < b.order ? -1 : 1))
        break
      case 'name':
        breads.sort((a, b) => (a.name < b.name ? -1 : 1))
        break
      default:
        breads.sort((a, b) => (a.name < b.name ? -1 : 1))
        break
    }

    dispatch(hideLoadingAction())
    dispatch(fetchBreadsAction(breads))
  }
}

export default fetchBreads
